import http from './http';

export async function getOrCreateOpenFundRequest() {
  const { data } = await http.post('/api/saving/meitav-dash/open-fund-requests');
  return data;
}

export async function getOpenFundRequests() {
  const { data } = await http.get('/api/saving/meitav-dash/open-fund-request');
  return data;
}

export async function submitOpenFundRequest(requestId) {
  const { data } = await http.post(`/api/saving/meitav-dash/open-fund-requests/${requestId}/submit`);
  return data;
}

export async function saveWizardState(requestId, state) {
  await http.put(`/api/saving/meitav-dash/open-fund-requests/${requestId}/wizard-state`, state);
}

export async function getWizardState(requestId) {
  const { data } = await http.get(`/api/saving/meitav-dash/open-fund-requests/${requestId}/wizard-state`);
  return data;
}

export async function getAllCityOptions() {
  const { data } = await http.get('/api/saving/city-and-street/city');
  return data;
}

export async function getCityStreetsOptions(city) {
  const { data } = await http.post('/api/saving/city-and-street/street', { city });
  return data;
}
